import {useCallback} from "react";

import {GuideStateApi} from "@khan/guide-state";
import type {NotificationParams} from "@khan/guide-types";
import Log, {Errors} from "@khan/logging";

import {useInitializeGuide} from "./hooks/use-initialize-guide.ts";
import {useSendGuideCommand} from "./hooks/use-send-guide-command.ts";

/**
 * Sends a notification/dispatch-request event to the ai-guide service to
 * build a notification for the associated trigger and stream it to the client
 * to be handled by the NotificationStreamListener.
 */
export const useRequestNotificationDispatch = () => {
    const sendGuideCommand = useSendGuideCommand();
    const initialize = useInitializeGuide();
    return useCallback(
        async (notificationParams: NotificationParams) => {
            try {
                const navigationId = GuideStateApi.latest().navigation.id;
                await initialize();
                await sendGuideCommand("notification/dispatch-request", {
                    ...notificationParams,
                    navigationId,
                });
            } catch (error: any) {
                Log.error(
                    "Failed to send notification/dispatch-request event to ai-guide.",
                    Errors.TransientKhanService,
                    {cause: error},
                );
            }
        },
        [initialize, sendGuideCommand],
    );
};
